export const startCheckout = async (apiCall, productId) => {
  try {
    const req = { productId };
    const resp = await apiCall(
      `/payment/stripe/createCheckoutSession`,
      "POST",
      req
    );
    if (resp.error) {
      return null;
    }
    return resp;
  } catch (error) {
    return null;
  }
};

export const getUsage = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs("/user/usage", JSON.stringify({}));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getPayments = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs(
    "/user/payment/history",
    JSON.stringify({})
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getRequestBalance = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs(
    "/user/requestBalance",
    JSON.stringify({})
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const cancelSubscription = async (apiCall) => {
  try {
    const resp = await apiCall(
      `/payment/stripe/cancelSubscription`,
      "POST",
      {}
    );
    if (resp.error) {
      return null;
    }
    return resp;
  } catch (error) {
    return null;
  }
};
